import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormTransaction } = Forms
        const { onResetForm } = FormTransaction

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllTransactions = async () => {

        const { fetchAllTransactions } = FetchData
        const { executeFetch } = fetchAllTransactions

        executeFetch()

    }

    const handleClickFetchSpecificTransaction = async (idmovimiento, flagShowForm) => {

        const { fetchSpecificTransaction } = FetchData
        const { FormTransaction } = Forms
        const { setFormState} = FormTransaction

        console.log({idmovimiento, flagShowForm})

        fetchSpecificTransaction.setParamsToSearch({
            idmovimiento: idmovimiento,
            fecthTransactionInfo: {
                flag: true,
                refSetFormState: setFormState
            }
        })
        fetchSpecificTransaction.executeFetch()

        handleClickShowForm(flagShowForm)
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        // const enlaceTemporal = document.createElement('a');
        // enlaceTemporal.href = openUrl;
        // enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
        // document.body.appendChild(enlaceTemporal);
        // enlaceTemporal.click();
        // document.body.removeChild(enlaceTemporal);

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }

    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { FormTransaction } = Forms
        const { formState, onResetForm } = FormTransaction

        const _data = { 
            idmovimiento: formState.idmovimiento,
            aprobacion_check: formState.aprobacion_check,
            aprobacion_usuario: user.username,
            // aprobacion_fecha: formState.aprobacion_fecha,
            aprobacion_fecha: new Date(),
            aprobacion_observaciones: formState.aprobacion_observaciones
        }

        console.log('onSubmitForm: ', _data)

        await marvarApi.post( `/leases/admin-payments/registrar-aprobacion`, _data )
            .then(({ data }) => {

                // alertMessage(data)
                toast.success(data.data.msg, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })

                onResetForm()
                handleClickFetchAllTransactions()
                handleClickHideForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)

                toast.warn(`Hubo un problema interno, detalles técnicos: ${error}`, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })

                onResetForm()
                handleClickFetchAllTransactions()
                handleClickHideForm()
            })
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllTransactions,
        handleClickFetchSpecificTransaction,
        handleClickDownloadImage,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}